function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import clone from 'ramda/src/clone';
import pathOr from 'ramda/src/pathOr';
import propEq from 'ramda/src/propEq';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import moment from 'moment';
import { TELEPHONE_SELECTION_COUNTRY_CODE_KEY } from '../constants/wizard.constants';
import { BILLER_RULE_INSTANCE_TYPE, ZERO_DOWNPAYMENT } from '../../customercare.constants';
import { discountTypes } from '../../components/shared/decisionOverrideDiscountDialog/decision.override.discount.dialog.helper';
import { GetDownPaymentTypeValue } from '../helpers/offer.ordering.wizard.selector.helper';
export var selectFutureDatedOrderConfigurationMaxDateForCurrentBusinessUnit = function selectFutureDatedOrderConfigurationMaxDateForCurrentBusinessUnit(fdoConfiguration) {
  var selectedFdoConfigObject = findNonGlobalOrReturnGlobal(fdoConfiguration);
  if (selectedFdoConfigObject) {
    var maxDate = selectedFdoConfigObject.AdditionalProperties.find(propEq('maximum_maturity_term_days', 'Key'));
    var today = moment();
    today.add(convertStringToNumber(maxDate.Value), 'days');
    return today.startOf('day').utc().toISOString();
  }
};
export var selectFutureDatedOrderConfigurationIsAllowedForCurrentBusinessUnit = function selectFutureDatedOrderConfigurationIsAllowedForCurrentBusinessUnit(fdoConfiguration) {
  var selectedFdoConfigObject = findNonGlobalOrReturnGlobal(fdoConfiguration);
  if (selectedFdoConfigObject) {
    return selectedFdoConfigObject.AdditionalProperties.find(propEq('is_future_dated_ordering_enabled', 'Key')).Value === 'True';
  }
};
var findNonGlobalOrReturnGlobal = function findNonGlobalOrReturnGlobal(fdoConfig) {
  return fdoConfig.find(function (x) {
    return !x.Global;
  }) || fdoConfig.find(function (x) {
    return x.Global;
  });
};
export var setDownPaymentProperties = function setDownPaymentProperties(item, downPayment, financedFullAmount, isFullPriceDownPaymentSelected) {
  item.downPayment = downPayment;
  item.isFullPriceDownPaymentSelected = isFullPriceDownPaymentSelected;
  item.isDownPaymentEqualToFirstSelected = !isFullPriceDownPaymentSelected;
  item.DownPaymentAmount = isFullPriceDownPaymentSelected ? financedFullAmount : downPayment;
  item.DownPaymentType = GetDownPaymentTypeValue(item);
  return item;
};
export var isFinancedShoppingCartItem = function isFinancedShoppingCartItem(item) {
  // There can be only 1 Financed BRI on the Pricing Plan.
  var financeBillerRuleInstance = pathOr(null, ['Details', 'PricingPlan', 'PricingPlanBillerRuleInstances', 'FinanceBillerRuleInstances', '0'], item);
  var isFinancedItem = financeBillerRuleInstance ? financeBillerRuleInstance.Type === BILLER_RULE_INSTANCE_TYPE.FINANCE : false;
  return {
    isFinancedItem: isFinancedItem,
    minimumDownPayment: isFinancedItem ? financeBillerRuleInstance.MinimumDownPaymentAmount || ZERO_DOWNPAYMENT : ZERO_DOWNPAYMENT,
    isFullUpfrontPayment: isFinancedItem ? financeBillerRuleInstance.FullUpfrontPayment || false : false
  };
};
export function filterStatesByCountry(states, country) {
  return states.filter(function (state) {
    return mapAdditionalProperties(state).country_code === country;
  });
}
export function findAndAttachStateName(states, names) {
  return Object.values(states).map(function (state) {
    var stateFound = findState(state.stateCode, names);
    return Object.assign({}, state, {
      stateName: stateFound ? stateFound.Name : state.stateCode
    });
  });
}
export function findState(stateCode, states) {
  return states.find(function (state) {
    return state.Value === stateCode;
  });
}
export function filterByCountry(codes, country) {
  return codes.filter(function (code) {
    var countryProp = code.AdditionalProperties.find(function (addProp) {
      return addProp.Key === TELEPHONE_SELECTION_COUNTRY_CODE_KEY;
    });
    return countryProp.Value === country;
  });
}
export function mapCodesAdditionalProperties(codes) {
  return codes.map(mapAdditionalProperties);
}
function mapAdditionalProperties(code) {
  var additionalProps = {};
  code.AdditionalProperties.forEach(function (addProp) {
    additionalProps[addProp.Key] = addProp.Value;
  });
  return additionalProps;
}
function createStateNpa(states, code) {
  var npaCodes = {
    Id: '',
    nxx: []
  };
  if (!states[code.state_code].locations[code.location].codesNpa[code.npa]) {
    states[code.state_code].locations[code.location].codesNpa[code.npa] = clone(npaCodes);
    states[code.state_code].locations[code.location].codesNpa[code.npa].Id = code.npa;
    if (states[code.state_code].locations[code.location].codesNpa[code.npa].nxx.indexOf(code.nxx) === -1) {
      states[code.state_code].locations[code.location].codesNpa[code.npa].nxx.push(code.nxx);
    }
  } else {
    if (states[code.state_code].locations[code.location].codesNpa[code.npa].nxx.indexOf(code.nxx) === -1) {
      states[code.state_code].locations[code.location].codesNpa[code.npa].nxx.push(code.nxx);
    }
  }
  return states;
}
export function reduceByState(codes) {
  var states = {};
  codes.forEach(function (code) {
    var location = {
      name: code.location,
      codes: [code.nxx],
      codesNpa: {}
    };
    if (!states[code.state_code]) {
      states[code.state_code] = {
        stateCode: code.state_code,
        stateName: code.state_code,
        code: {},
        locations: {}
      };
      states[code.state_code].code[code.npa] = code.npa;
      states[code.state_code].locations[code.location] = location;
      states = createStateNpa(states, code);
    } else {
      states[code.state_code].code[code.npa] = code.npa;
      if (!states[code.state_code].locations[code.location]) {
        states[code.state_code].locations[code.location] = location;
        states = createStateNpa(states, code);
      } else {
        states[code.state_code].locations[code.location].codes.push(code.nxx);
        states = createStateNpa(states, code);
      }
    }
  });
  return states;
}
export var getChargeAmount = function getChargeAmount(briCharges) {
  if (briCharges.length === 1) {
    return briCharges[0].ChargeAmount;
  } else {
    var _briCharges$find;
    return (_briCharges$find = briCharges.find(function (briCharge) {
      return moment(moment(new Date()).startOf('day').utc().toISOString()).isBetween(briCharge.StartDate, briCharge.EndDate);
    })) === null || _briCharges$find === void 0 ? void 0 : _briCharges$find.ChargeAmount;
  }
};
export var getDiscountDisplayAmount = function getDiscountDisplayAmount(discountMetadata) {
  return discountMetadata.Type === convertStringToNumber(discountTypes.amountOff.value) ? discountMetadata.Amount : Math.round(discountMetadata.Amount * 100);
};
export var isChargeOverridableOption = function isChargeOverridableOption(option) {
  var filteredBris = option.PricingPlanBillerRuleInstances ? [].concat(_toConsumableArray(option.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances), _toConsumableArray(option.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances), _toConsumableArray(option.PricingPlanBillerRuleInstances.FinanceBillerRuleInstances)) : [];
  return filteredBris.some(function (bri) {
    return bri.AllowChargeOverride;
  });
};